import React from 'react';

import NewPatient from './NewPatient';

export default function PatientModal({ isOpen = false, handleClose = () => {} }) {
  if (!isOpen) return null;

  return <NewPatient newPatientModal={isOpen} hideNewPatientModal={handleClose} />;
}
